import React, { useEffect, useRef } from 'react';

const SCRIPT_ID = 'cloudflare-turnstile-script';

const loadTurnstile = () => {
    if (window.turnstile) {
        return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
        const existing = document.getElementById(SCRIPT_ID);
        if (existing) {
            existing.addEventListener('load', resolve, { once: true });
            existing.addEventListener('error', reject, { once: true });
            return;
        }

        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
};

const TurnstileWidget = ({ action, onToken, resetKey }) => {
    const containerRef = useRef(null);
    const widgetIdRef = useRef(null);
    const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

    useEffect(() => {
        let cancelled = false;

        if (!siteKey) {
            onToken('');
            return undefined;
        }

        loadTurnstile().then(() => {
            if (cancelled || !containerRef.current || !window.turnstile) {
                return;
            }

            widgetIdRef.current = window.turnstile.render(containerRef.current, {
                sitekey: siteKey,
                action,
                callback: onToken,
                'expired-callback': () => onToken(''),
                'error-callback': () => onToken(''),
            });
        }).catch(() => onToken(''));

        return () => {
            cancelled = true;
            if (widgetIdRef.current && window.turnstile) {
                window.turnstile.remove(widgetIdRef.current);
                widgetIdRef.current = null;
            }
        };
    }, [action, onToken, resetKey, siteKey]);

    if (!siteKey) {
        return (
            <span className='error-form'>
                Le formulaire est temporairement indisponible.
            </span>
        );
    }

    return <div ref={containerRef} />;
};

export default TurnstileWidget;
